import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Product from "./Product";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Loader from "./Loader";
import { useLocation } from "react-router-dom";

const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  justify-content: center;
`;

const ButtonGo = styled.button`
  background-color: rgb(99, 91, 255);
  font-size: 18px;
  color: #fff;
  font-weight: 500;
  min-height: 40px;
  margin: 1em 0 1em 0;
  border: solid 2px rgb(99, 91, 255);
  border-radius: 10px;
  width: 105%;
  cursor: pointer;

  &:hover {
    background-color: rgb(107, 100, 250);
  }
`;
const NoResults = styled.div`
  background-color: "#C7C7C7";
  margin: auto;
`;

const Products = ({ cat, filters, sort }) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState();
  const location = useLocation();
  const paramSub = location.pathname.split("/")[3];

  const componentDidMount = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    const getProducts = async () => {
      if (cat !== undefined) {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/products?category=${
              cat ? cat : ""
            }&size=${filters?.size ? filters?.size : ""}&colour=${
              filters?.colour ? filters?.colour : ""
            }&subcategory=${paramSub !== undefined ? paramSub : ""}`
          );
          setStatus(res.status);
          setProducts(res.data);
        } catch (err) {}
      } else {
        try {
          if (sort === "newest") {
            const res = await axios.get(
              `${process.env.REACT_APP_API_URL}/products?new=1`
            );
            setStatus(res.status);
            setProducts(res.data);
          } else if (
            cat === undefined &&
            filters === undefined &&
            sort === "refresh"
          ) {
            const res = await axios.get(
              `${process.env.REACT_APP_API_URL}/products/recent`
            );
            setStatus(res.status);
            setProducts(res.data);
          }
        } catch (err) {}
      }
    };
    getProducts();
    componentDidMount();
  }, [cat, filters]);

  useEffect(() => {
    const filterProducts = () => {
      try {
        products !== undefined &&
          filters !== undefined &&
          setFilteredProducts(products);

        if (sort?.sort === "asc") {
          setFilteredProducts((prev) => {
            return [...prev].sort((a, b) => a?.price - b?.price);
          });
        } else if (sort?.sort === "desc") {
          setFilteredProducts((prev) =>
            [...prev].sort((a, b) => b?.price - a?.price)
          );
        }
      } catch (err) {}
    };

    filterProducts();
  }, [products]);

  useEffect(() => {
    const setSort = () => {
      if (sort?.sort === "asc") {
        setFilteredProducts((prev) => {
          return [...prev].sort((a, b) => a?.price - b?.price);
        });
      } else if (sort?.sort === "desc") {
        setFilteredProducts((prev) =>
          [...prev].sort((a, b) => b?.price - a?.price)
        );
      }
    };

    setSort();
  }, [sort.sort]);

  const resetFilters = async (e) => {
    e.preventDefault();
    history.go(0);
  };
  const handleChange = (event, value) => {
    setPage(value);
  };
  return (
    <>
      <Container>
        {sort === "refresh" ? (
          products.map((item) => <Product item={item} key={item._id} />)
        ) : status === undefined ? (
          <Loader />
        ) : JSON.stringify(filteredProducts) === "[]" ? (
          <NoResults>
            <h1>Sorry, no results for that.</h1>
            <ButtonGo onClick={resetFilters}>Reset Filters</ButtonGo>
            <p>Do you have something you could lend?</p>
            <Link to="/upload" style={{ textDecoration: "none" }}>
              <ButtonGo>Lend Yours!</ButtonGo>
            </Link>
          </NoResults>
        ) : (
          filteredProducts
            .slice((page - 1) * 12, 12 * page)
            .map((item) => <Product item={item} key={item._id} />)
        )}
      </Container>

      {JSON.stringify(filteredProducts) !== "[]" &&
        filteredProducts?.length / 12 > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1em",
            }}
          >
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(filteredProducts?.length / 12)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        )}
    </>
  );
};

export default Products;
